<app-dashboard-element icon="community" [title]="'Aide FAQ lorem'"
    description="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nulla, aliquam.">

    <div class="panels-container" #panelsContainer [style.height.px]="containerHeight()">
        @if(activeIndex() === undefined){
        <div class="panel" animate.enter="list-enter" animate.leave="list-leave">
            <ul class="questions-list">
                @for(item of items; track $index;let last = $last){
                @if(item.tips) {
                <li class="question-item" (click)="openItem($index)">
                    <kin-icon class="question-icon" [name]="item.icon" [color]="colorService.neutral600()" />
                    <p>{{item.title}}</p>
                    <kin-icon name="arrow_right" class="nav-icon" [color]="colorService.neutral500()" />
                </li>
                } @else {
                <a class="question-item" [href]="item.url" target="_blank" rel="noopener noreferrer"
                    (mouseenter)="hoveredIndex.set($index)" (mouseleave)="hoveredIndex.set(null)">
                    <kin-icon class="question-icon" [name]="item.icon" [color]="colorService.neutral600()" />
                    <p>{{item.title}}</p>
                    <kin-icon name="external" class="nav-icon"
                        [color]="hoveredIndex() === $index ? colorService.brandSecondary500() : colorService.neutral500()" />
                </a>
                }
                @if(!last){
                <span class="divider"></span>
                }
                }
            </ul>
        </div>
        } @else {
        @let item = items[activeIndex()!];
        <div class="panel tips-panel" animate.enter="tips-enter" animate.leave="tips-leave">
            <header>
                <kin-icon (iconClick)="closeItem()" name="arrow_left" />
                <p>{{item.title}}</p>
            </header>
            <p class="tips-text">{{item.tips}}</p>
            <a [href]="item.url" target="_blank">{{ 'faq.learn_more' | translate }}
                <kin-icon name="external" [color]="colorService.brandSecondary600()" />
            </a>
        </div>
        }
    </div>

</app-dashboard-element>